import { render } from "./MessageList.vue?vue&type=template&id=18df9098&ts=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__